import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-26deacf0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "onlineService"
};
const _hoisted_2 = {
  class: "onlinekefu-questionItem"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "热点问题", -1));

const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "onlinekefu-btn-box"
};
const _hoisted_6 = {
  class: "details_page"
};
const _hoisted_7 = {
  class: "head_title"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "问题详情", -1));

const _hoisted_9 = {
  class: "cont_body"
};
const _hoisted_10 = {
  class: "questionDetail"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_van_popup = _resolveComponent("van-popup");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "onlinekefu-questionItem-item",
      onClick: $event => $setup.toDetails(item)
    }, _toDisplayString(item.title) + " >> ", 9, _hoisted_4);
  }), 128))]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: "onlinekefu-btn",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.toKefu && $setup.toKefu(...args))
  }, "在线客服")]), _createVNode(_component_van_popup, {
    show: $setup.showDetailsPopul,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => $setup.showDetailsPopul = $event),
    overlay: false,
    position: "right",
    class: "popup_coentent"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_van_icon, {
      size: "22",
      name: "arrow-left",
      onClick: $setup.close
    }, null, 8, ["onClick"]), _hoisted_8]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("p", null, _toDisplayString($setup.detailsTitle), 1), _createElementVNode("p", null, _toDisplayString($setup.content), 1)])])])]),
    _: 1
  }, 8, ["show"])]);
}